import { render } from "./InsertInstitute.vue?vue&type=template&id=a5ad1e9c&scoped=true"
import script from "./InsertInstitute.vue?vue&type=script&lang=js"
export * from "./InsertInstitute.vue?vue&type=script&lang=js"

import "./InsertInstitute.vue?vue&type=style&index=0&id=a5ad1e9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ad1e9c"]])

export default __exports__